import * as React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography,
} from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { ScheduleEntry } from '../../../domain/ScheduleEntry';
import { withLazyMounting } from '../../../components/hoc/LazyDialog';
import { useStores } from '../../../stores';

interface Props {
    entry: ScheduleEntry;
    isOpen: boolean;
    onClose: () => void;
}

const ScheduleAssignmentHistoryDialog = (props: Props) => {
    const { t } = useTranslation();
    const { scheduleStore } = useStores();
    const [history, setHistory] = React.useState<ScheduleEntry[]>([]);

    React.useEffect(() => {
        scheduleStore.getScheduleEntryHistory(props.entry.id!, (historyEntries) => {
            setHistory(historyEntries || []);
        });
    }, [props.entry.id, props.isOpen, scheduleStore]);

    const handleClose = () => {
        props.onClose();
    };

    const hasHistory = history.length > 0;
    const entryName = props.entry.name;

    return (
        <Dialog open={props.isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', columnGap: 1, flexWrap: 'wrap' }}>
                {t('assignment_history')}
                {entryName && (
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        {entryName}
                    </Typography>
                )}
            </DialogTitle>
            <DialogContent>
                {!hasHistory && (
                    <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                        {t('no_assignment_history')}
                    </Typography>
                )}
                {hasHistory && (
                    <Table size="small">
                        <TableBody>
                            {history.map((historyEntry, index) => {
                                const speaker = historyEntry.speaker;
                                const publisherName = speaker
                                    ? `${speaker.lastName} ${speaker.firstName}`
                                    : t('someone');
                                return (
                                    <TableRow key={historyEntry.id ?? index}>
                                        <TableCell sx={{ width: '40%' }}>
                                            {moment(historyEntry.week!.date).format('DD/MM/YYYY')}
                                        </TableCell>
                                        <TableCell>{publisherName}</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{t('close')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default withLazyMounting(ScheduleAssignmentHistoryDialog);
